export const formatEmailTitle = (title: string, depth = 0): string => {
  if (depth > 50) return title;

  if (title.startsWith("Re: ")) {
    const latestTitle = title.replace("Re: ", "");
    return formatEmailTitle(latestTitle, depth + 1);
  }

  return title;
};
